import 'picturefill'
import OCTRenderQueue from '../../plugins/oct-render-queue'
import OCTImageCover from '../image-cover/index'
import OCTParallaxClip from '../parallax-clip/index'
import './oct-media.scss'

document.addEventListener('DOMContentLoaded', event => { // eslint-disable-line no-unused-vars
  // parallax
  Array.from(document.querySelectorAll('.oct-media__image[data-parallax="clip"]')).forEach(el => {
    new OCTParallaxClip(el)
  })

  // image cover
  Array.from(document.querySelectorAll('.oct-media__image[data-image-size="cover"]')).forEach(el => {
    new OCTImageCover(el)
  })

  OCTRenderQueue.flush()
})
